import { render, staticRenderFns } from "./DashboardOs.vue?vue&type=template&id=0e198d41&scoped=true&"
import script from "./DashboardOs.vue?vue&type=script&lang=ts&"
export * from "./DashboardOs.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardOs.vue?vue&type=style&index=0&id=0e198d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e198d41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0e198d41', component.options)
    } else {
      api.reload('0e198d41', component.options)
    }
    module.hot.accept("./DashboardOs.vue?vue&type=template&id=0e198d41&scoped=true&", function () {
      api.rerender('0e198d41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dashboard/DashboardOs.vue"
export default component.exports